import {REG} from "lib/commons/registry";
import {Action} from "lib/commons/actions";
import {BoxContainer} from "back/edit/wed/wedlets/box/boxTags";
import {EWedletEditMode, isEditableWedlet, IWedletActionCtx} from "back/edit/wed/wedlets/wedlet";
import {IXmlIdMgr} from "lib/edit/schema/xmlIdMgr";
import {POPUP} from "back/commons/widgets/popups";
import {JSX, ShadowJsx} from "lib/commons/xml/dom";
import {Button, OButtonInit} from "back/commons/widgets/buttons";
import {DOMSH} from "lib/commons/xml/domsh";
import {IJmlNode, IJmlSubSet} from "lib/commons/xml/jml";
import {IXmlMsg} from "lib/edit/ot/xmlHouse";
import {MsgLabel, OMsgLabelInit} from "back/commons/basis";
import "back/edit/wed/wedlets/wedlets_Perms";

// Base d'un widget pour gérer un xml:id.
export abstract class BoxId extends BoxContainer {

	fragmentId: string;

	refreshBindValue(val: IJmlNode, children?: IJmlSubSet) {
		super.refreshBindValue(val, children);
		this.fragmentId = val ? val.toString() : null;
		this.onFragmentIdChanged();
	}

	replaceChars(chars: string, msg: IXmlMsg) {
		super.replaceChars(chars, msg);
		this.fragmentId = chars;
		this.onFragmentIdChanged();
	}

	protected onFragmentIdChanged(){}
}

// AgEltBoxSelection(BoxId, {selMode: 'box', actionsLists: ['actions:wed:box-id', 'actions:wed:box'], groupOrder: '* edit'});
// window.customElements.define("box-id", BoxId);

/**
 * Action de génération d'un nouvel Id via l'aspect XmlIdMgr du docHolder.
 */
REG.reg.addToList("actions:wed:box-id", "changeId", 1, new Action<IWedletActionCtx>("changeId")
	.setLabel("Changer d'identifiant")
	.setGroup("edit")
	.setIcon("/@skin@/edit/wed/box/changeId.svg")
	.setVisible((ctx: IWedletActionCtx) => !ctx.wedlet.isVirtual() && isEditableWedlet(ctx.wedlet) && ctx.wedlet.editMode === EWedletEditMode.write)
	.setEnabled((ctx: IWedletActionCtx) => ctx.wedlet.wedMgr.reg.hasPerm("action.wed#change.box-id"))
	//.requireEnabledPerm("action.wed#change.box-id") FIXME6 : manque le reg dans IWedletActionCtx pour faire fonctionner checkObjectRootPerm
	.setExecute(async (ctx: IWedletActionCtx) => {
		if (await POPUP.confirm("Attention : Changer d'identifiant aura pour effet de casser les liens établis vers ce fragment.",
			ctx.focusedElt, {okLbl: "Changer d'identifiant", kind: "warning"})) {
			const docHolder = ctx.wedlet.wedMgr.docHolder;
			const xa = ctx.wedlet.wedAnchor;
			const mgrId = docHolder.getAspect<IXmlIdMgr>(xa, null, "XmlIdMgr");
			if (mgrId) docHolder.newBatch({start: xa}).setAttr(xa, mgrId.generateId(new Set())).doBatch();
		}
	})
);

/**
 * Action d'édition directe du xml:id.
 */
REG.reg.addToList("actions:wed:box-id", "editId", 1, new Action<IWedletActionCtx>("editId")
	.setLabel("Éditer l'identifiant")
	.setGroup("edit")
	.setIcon("/@skin@/edit/wed/box/editId.svg")
	.setVisible((ctx: IWedletActionCtx) => !ctx.wedlet.isVirtual() && isEditableWedlet(ctx.wedlet) && ctx.wedlet.editMode === EWedletEditMode.write)
	//.requireEnabledPerm("action.wed#edit.box-id") FIXME6 : manque le reg dans IWedletActionCtx pour faire fonctionner checkObjectRootPerm
	.setEnabled((ctx: IWedletActionCtx) => ctx.wedlet.wedMgr.reg.hasPerm("action.wed#edit.box-id"))
	.setExecute(async (ctx: IWedletActionCtx) => {
		const docHolder = ctx.wedlet.wedMgr.docHolder;
		const boxId = ctx.focusedElt as BoxId;
		const newId = await POPUP.showDialog<string>(<div><ShadowJsx skin="standard-dialog" skinOver="webzone:panel">
			<style>{/* language=CSS */ `
		  :host {
			  min-width: 20em;
			  width: 20em;
		  }

		  #body {
			  display: flex;
			  flex-direction: column;
			  min-height: 0;
			  min-width: 0;
			  padding: .5em;
		  }

		  #msg {
			  padding: .5em 0;
		  }

		  label {
			  display: flex;
			  flex-direction: column;
			  min-height: 0;
			  min-width: 0;
		  }

			`}</style>
			<div id="body">
				<MsgLabel id="msg" î={{
					label: "Attention, changer d'identifiant aura pour effet de casser les liens établis vers ce fragment.",
					level: "warning", icon: "/@skin@/commons/widgets/popupable/warning.svg"
				} as OMsgLabelInit}/>
				<label>
					<div>Nouvel identifiant</div>
					<input id="input" value={boxId.fragmentId}/>
				</label>
			</div>
			<div id="footer">
				<Button î={{label: "Changer", uiContext: "dialog"} as OButtonInit} onclick={function (this: Button) {
					POPUP.findPopupableParent(this).close((DOMSH.findDocumentOrShadowRoot(this).getElementById('input') as HTMLInputElement).value);
				}
				}/>
				<Button î={{label: "Annuler", uiContext: "dialog"} as OButtonInit} onclick={function (this: Button) {
					POPUP.findPopupableParent(this).close(null);
				}
				}/>
			</div>
		</ShadowJsx></div>, ctx.focusedElt, {titleBar: "Éditer cet identifiant"}).onNextClose();
		const xa = ctx.wedlet.wedAnchor;
		if (newId && newId !== boxId.fragmentId) docHolder.newBatch({start: xa}).setAttr(xa, newId).doBatch();
	})
);


REG.reg.addToList("actions:wed:box-id", "scComment", 2, null);
REG.reg.addToList("actions:wed:box-id", "delete", 2, null);